import { PaperStatus, PaperType } from '@chegg-wt/core/types/paraphraser'

export const ActionTypes = {
  OPEN_PUSHER_CONNECTION: 'PUSHER/OPEN-CONNECTION',
  RUN_PROOFREAD_CHECKS: 'CHECK/RUN_CHECKS',
  SET_FEEDBACKS: 'PARAPHRASER/SET_FEEDBACKS',
  APPEND_TO_FEEDBACKS: 'PARAPHRASER/APPEND_TO_FEEDBACKS',
  SET_PARAPHRASE_FLAG: 'PARAPHRASER/SET_PARAPHRASE_FLAG',
  SET_PAPER_STATUS: 'PARAPHRASER/SET_PAPER_STATUS',
  SET_FEEDBACK_REASON: 'PARAPHRASER/SET_FEEDBACK_REASON',
  SET_SENTENCE_OFFSETS: 'PARAPHRASER/SET_SENTENCE_OFFSETS',
  ADJUST_SENTENCE_OFFSETS: 'PARAPHRASER/ADJUST_SENTENCE_OFFSETS',
  SET_ACTIVE_FEEDBACK_TAB: 'PARAPHRASER/SET_ACTIVE_FEEDBACK_TAB',
  SET_IS_PAPER_CHECK_IN_PROGRESS: 'PARAPHRASER/SET_IS_PAPER_CHECK_IN_PROGRESS',
  SET_REWRITE_PANEL_SENTENCES: 'PARAPHRASER/SET_REWRITE_PANEL_SENTENCES',
  SET_QUICK_ACTION_PANEL_TYPE: 'PARAPHRASER/SET_QUICK_ACTION_PANEL_TYPE',
  SET_ACTIVE_FEEDBACK_CARD_ID: 'PARAPHRASER/SET_ACTIVE_FEEDBACK_CARD_ID',
  SET_IS_TIMED_OUT: 'PARAPHRASER/SET_IS_TIMED_OUT',
  DELETE_FEEDBACK: 'PARAPHRASER/DELETE_FEEDBACK',
  UPDATE_TOTAL_FEEDBACK_COUNT: 'PARAPHRASER/UPDATE_TOTAL_FEEDBACK_COUNT',
  SET_TOTAL_FEEDBACK_COUNT: 'PARAPHRASER/SET_TOTAL_FEEDBACK_COUNT',
  SET_PAPER_ID: 'PARAPHRASER/SET_PAPER_ID',
  SET_PAPER_TITLE: 'PARAPHRASER/SET_PAPER_TITLE',
  SET_PAPER_REQUIRES_RECHECK: 'PARAPHRASER/SET_PAPER_REQUIRES_RECHECK',
  UPDATE_PAPER_HANDLER: 'PARAPHRASER/UPDATE_PAPER_HANDLER',
  SET_WORD_COUNT: 'PARAPHRASER/SET_WORD_COUNT',
  NOTIFY_TOAST: 'PARAPHRASER/NOTIFY_TOAST',
  NOTIFY_ERROR_TOAST: 'PARAPHRASER/NOTIFY_ERROR_TOAST',
  CLEAR_TOAST: 'PARAPHRASER/CLEAR_TOAST',
  SET_FETCH_NEW_SENTENCES_LOADING: 'PARAPHRASER/SET_FETCH_NEW_SENTENCES_LOADING',
  SET_WRITING_ASSISTANT_HOME_FLAG: 'PARAPHRASER/SET_WRITING_ASSISTANT_HOME_FLAG',
  SET_CITATION_FUNNEL_VARIATION: 'PARAPHRASER/SET_CITATION_FUNNEL_VARIATION',
  SET_WRITING_ASSISTANT_ENABLED_FEATURES:
    'PARAPHRASER/SET_WRITING_ASSISTANT_ENABLED_FEATURES',
  WRITING_ASSISTANT_TRANSFER_OF_OWNERSHIP: 'WRITING_ASSISTANT_TRANSFER_OF_OWNERSHIP',
  RESET_PAPER: 'PARAPHRASER/RESET_PAPER',
  NEW_DOC_CREATION_REQUEST: 'PARAPHRASER/NEW_DOC_CREATION_REQUEST',
  SET_UNDO_ENABLED: 'SET_UNDO_ENABLED',
  SET_REDO_ENABLED: 'SET_REDO_ENABLED',
  SET_IS_PAPER_REVIEWED: 'SET_IS_PAPER_REVIEWED',
  SET_PAPER_LIST: 'PARAPHRASER/SET_PAPER_LIST',
  SET_IS_TRANSFER_OF_OWNERSHIP_IN_PROGRESS:
    'PARAPHRASER/SET_IS_TRANSFER_OF_OWNERSHIP_IN_PROGRESS',
  IS_LOGGING_OUT: 'PARAPHRASER/IS_LOGGING_OUT',
} as const

export const SYNONYM_ERROR_HEADING = 'Uh oh!'
export const SYNONYM_ERROR_BODY =
  'Looks like something went wrong, let’s try reloading synonyms again.'
export const SYNONYM_ERROR_BUTTON_TEXT = 'Try Again'

export const REWRITE_ERROR_HEADING = 'Something didn’t go as planned'
export const REWRITE_ERROR_BODY = 'Your suggestions are taking longer than usual to load.'
export const REWRITE_ERROR_BUTTON_TEXT = 'Retry'
export const ALL_CARDS_ACCEPTED_HEADING = 'You’ve successfully completed your review'
export const NICELY_DONE_TEXT = 'Nicely Done!'
export const KEEP_IMPROVING_TEXT = 'Keep improving your writing...'
export const GO_TEXT = 'Go'
export const KEEP_UP_GOOD_WORK = 'Keep Up The Good Work'

export enum QuickActionLoadingStatus {
  PARAPHRASE = 'Paraphrasing your writing...',
  EXPAND = 'Expanding your writing...',
  SHORTEN = 'Shortening your writing...',
}

export const PARAPHRASE_PANEL_TITLE = "Here's what we suggest"
export const PARAPHRASE_ICON_DATA_TEST = 'paraphrase-icon'
export const SYNONYM_ICON_DATA_TEST = 'synonym-icon'
export const EXPAND_ICON_DATA_TEST = 'expand-icon'
export const SHORTEN_ICON_DATA_TEST = 'shorten-icon'

export const EMPTY_PAPER: PaperType = {
  paperId: null,
  title: 'Untitled',
  status: PaperStatus.DRAFT,
}

export const HOMEPAGE_CAROUSEL_AUTOSCROLL_DELAY_MS = 6000 // 6 seconds
